import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="w-full bg-[#faf9f7] py-8 md:py-16 px-4" data-id="element-268">
      <div className="max-w-7xl mx-auto" data-id="element-269">
        <h2 className="text-2xl md:text-5xl lg:text-6xl font-black text-gray-900 text-center mb-4 md:mb-6" data-id="element-270">
          Barberos que ya aplican{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#e53935] to-[#ff7043]" data-id="element-271">
            el método
          </span>
        </h2>
        <div className="w-20 md:w-32 h-1 bg-gradient-to-r from-[#e53935] to-[#ff7043] mx-auto mb-8 md:mb-14 rounded-full" data-id="element-272"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8" data-id="element-273">
          {[{
          quote: '"Ahora entiendo por qué hago cada corte. Uso el ebook como guía todos los días."',
          name: 'Lucas M.',
          city: 'Buenos Aires'
        }, {
          quote: '"Dejé de improvisar. El método te ordena la cabeza y el trabajo."',
          name: 'Matías R.',
          city: 'Córdoba Capital'
        }, {
          quote: '"No es un curso más. Es una formación bien pensada."',
          name: 'Nicolás G.',
          city: 'Rosario'
        }, {
          quote: '"Me ayudó a profesionalizarme y a cobrar mejor mis servicios."',
          name: 'Franco D.',
          city: 'La Plata'
        }].map(t => <div key={t.name} className="bg-white rounded-2xl p-5 md:p-8 shadow-md border border-gray-100" data-id="element-274">
              <QuoteIcon className="w-7 h-7 md:w-10 md:h-10 text-[#ef5350]/60 mb-4" aria-hidden="true" data-id="element-275" />
              <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-4" data-id="element-276">
                {t.quote}
              </p>
              <p className="text-gray-900 font-black text-sm md:text-base" data-id="element-277">
                {t.name} –{' '}
                <span className="text-gray-500 font-semibold" data-id="element-278">{t.city}</span>
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}